module.exports = __webpack_public_path__ + "img/slider_13.68b392e7.jpg";